// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import * as React from 'react';

export const ColorModeContext = React.createContext<ColorModeContextType | undefined>(undefined);

interface ColorModeContextType {
  readonly mode: 'light' | 'dark';
  readonly toggleMode: () => void;
}

export const useColorContext = (): ColorModeContextType => {
  const context = React.useContext(ColorModeContext);
  if (context === undefined) {
    throw new Error('useLocalState must be used within a LocalStateProvider');
  }
  return context;
};
